import { useState } from "react";

const EVENT_CAL_URL = "https://salumievents.eventcalendarapp.com/";

/**
 * EventCalendarWidget — embeds the Salumi Tucson public EventCalendarApp page
 * via iframe so the calendar appears exactly as it does at salumievents.eventcalendarapp.com,
 * with the third-party hosting taking care of fetching events, paging, etc.
 */
export default function EventCalendarWidget() {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className="relative w-full" data-testid="event-calendar-widget">
      {!loaded && (
        <div className="absolute inset-0 flex items-center justify-center text-[11px] uppercase tracking-[0.3em] text-espresso/45 pointer-events-none">
          Loading calendar…
        </div>
      )}
      <iframe
        title="Salumi Tucson — Upcoming Events"
        src={EVENT_CAL_URL}
        loading="lazy"
        onLoad={() => setLoaded(true)}
        className="w-full bg-ivory border-0"
        style={{ minHeight: "380px", height: "380px" }}
        allow="fullscreen; clipboard-write"
        referrerPolicy="no-referrer-when-downgrade"
        data-testid="event-calendar-iframe"
      />
    </div>
  );
}
